__turbopack_context__.v({
  "closeButton": "MobileSubNav-module__3KR1tG__closeButton",
  "mobileSubNav": "MobileSubNav-module__3KR1tG__mobileSubNav",
});
